import classNames from 'classnames';
import { ReactNode } from 'react';
import ReactMarkdown from 'react-markdown';
import Heading from './heading';

function renderListItem({ children }) {
  return <li>{children}</li>;
}

function renderHeading({ level, children }) {
  if (Array.isArray(children)) children = children.join(' ');
  return <Heading level={level}>{children}</Heading>;
}

const mdComponents = {
  li: renderListItem,
  h1: renderHeading,
  h2: renderHeading,
  h3: renderHeading,
  h4: renderHeading,
};

interface ContentArgs {
  center?: boolean;
  children?: ReactNode;
  className?: string;
  heading?: string;
  headingLevel?: 1 | 2 | 3 | 4;
}

/**
 * Renders text content either as Markdown or HTML depending on the children given.
 */
function Content({ className, center, children, heading, headingLevel = 3 }: ContentArgs) {
  const classes = classNames(['prose max-w-none', className, { 'text-center': center }]);

  if (heading || children) {
    return (
      <div className={classes}>
        {heading && <Heading level={headingLevel}>{heading}</Heading>}
        {typeof children === 'string' && (
          <ReactMarkdown components={mdComponents}>{children}</ReactMarkdown>
        )}
        {typeof children !== 'string' && children}
      </div>
    );
  } else {
    return null;
  }
}

export default Content;
